import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserStore} from 'src/app/modules/authentication/state/user.store';
import {API_PATH, RouterLinks} from '../../constants';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../authentication/service/authentication.service';

declare const Dropzone: any;
declare const dropzonePreviewTemplate: any;
declare var $: any;

@Component({
    selector: 'app-question-uploaders-documents',
    templateUrl: './question-uploaders-documents.component.html',
    styleUrls: ['./question-uploaders-documents.component.scss'],
    standalone: false
})
export class QuestionUploadersDocumentsComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() noteText = 'Note on what to take images of';
  @Input() labelText; // = 'Upload Images';
  @Input() showNoteText = false;
  @Input() showUploadLabelText = false;
  @Input() uploadLabelText = '<strong>Format:</strong> &lt;doc, docx, xls, xlsx, pdf&gt;&nbsp; <strong>Maximum size:</strong> &lt;20MB&gt;&lt;/20MB&gt;';
  @Output() questionAnswer = new EventEmitter<any>();

  dropZone: any;
  acceptedFileTypes = 'application/pdf,.doc,.docx,.xls,.xlsx';
  fileSelectorEl = `question-uploader-${newGuid()}`;
  savedResources: any[] = [];

  constructor(
    private userStore: UserStore,
    private globalQuestionService: GlobalQuestionService,
    private authService: AuthenticationService,
    private router: Router
    ) {
  }

  ngOnInit(): void {
    this.authService.refreshToken()
      .subscribe(x => {
        this.userStore.update({
          access_token: x?.access_token,
          refresh_token: x?.refresh_token
        });
      });
  }

  ngAfterViewInit(): void {
    this.dropZone = new Dropzone(`#${this.fileSelectorEl}`, {
      autoProcessQueue: true, // if false, call this.dropZone.processQueue()
      autoDiscover: false,
      acceptedFiles: this.acceptedFileTypes,
      previewTemplate: dropzonePreviewTemplate,
      thumbnailWidth: 204,
      thumbnailHeight: 204,
      maxFilesize: 200,
      url: API_PATH.UPLOAD_RESOURCE,
      headers: {
        Authorization: `Bearer ${this.userStore.getValue()?.access_token}`
      }
    }).on('thumbnail', (file: any) => {
      $(file.previewElement).addClass('has-thumbnail');
    }).on('success', (file: any, response: any) => {
      if (!this.savedResources || this.savedResources?.length) {
        this.savedResources = [];
      }
      this.savedResources.push({resource_id: response, file: file?.upload?.uuid});
      this.question.answer = JSON.stringify(this.savedResources);
      this.questionAnswer.emit(this.question);
    }).on('removedfile', (file: any) => {
      const deletedFile = this.savedResources.find((item: any) => item.file === file?.upload?.uuid);
      if (deletedFile) {
        this.savedResources = this.savedResources.filter((item: any) => item.file !== file?.upload?.uuid);
        this.removeFile(deletedFile.resource_id);
        if (!this.savedResources || this.savedResources?.length) {
          this.question.answer = '';
          this.questionAnswer.emit(this.question);
        }
      }
    }).on('error', (file: any, response: any) => {
      if (response?.indexOf('401') !== -1) {
        this.router.navigate([RouterLinks.Login], {queryParams: {returnUrl: this.router.routerState.snapshot.url}});
      }
    });

  }

  removeFile(resource_id: string): void {
    this.globalQuestionService.removeFile(resource_id);
  }


}
